import React from "react";
import TraceabilityVersionValue from "./TraceabilityVersionValue";
import "./ContextSection.css";

const ContextSection = ({ record, pendingBcomeVersionId }) => {
  return (
    <div className="context-section">
      <h3 className="context-section__title">Context</h3>
      <div className="context-section__content">
        <div className="context-section__field">
          <strong className="context-section__label">Name</strong>
          <div className="context-section__value">{record.name || "-"}</div>
        </div>
        <div className="context-section__field">
          <strong className="context-section__label">Version</strong>
          <div className="context-section__value">
            <TraceabilityVersionValue
              record={record}
              pendingBcomeVersionId={pendingBcomeVersionId}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContextSection;
